import Text from './Text';
import { TextColor, TextWeight, TextSize, getSize, getColor, getWeight } from './utils';

export default function LgSemibold(props) {
  return (
    <Text
      {...props}
      size={TextSize.Lg}
      weight={TextWeight.Semibold}
    />
  );
}
